var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13092_122974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 0C5.2103 0 0.5 4.7103 0.5 10.5V14.8501C0.5 15.9253 1.44185 16.8 2.6 16.8H3.65C3.92848 16.8 4.19555 16.6894 4.39246 16.4925C4.58938 16.2955 4.7 16.0285 4.7 15.75V10.3498C4.7 10.0714 4.58938 9.8043 4.39246 9.60739C4.19555 9.41047 3.92848 9.29985 3.65 9.29985H2.6966C3.2804 5.23635 6.7769 2.1 11 2.1C15.2231 2.1 18.7196 5.23635 19.3034 9.29985H18.35C18.0715 9.29985 17.8044 9.41047 17.6075 9.60739C17.4106 9.8043 17.3 10.0714 17.3 10.3498V16.8C17.3 17.9581 16.3581 18.9 15.2 18.9H13.1V17.85H8.9V21H15.2C17.5163 21 19.4 19.1163 19.4 16.8C20.5581 16.8 21.5 15.9253 21.5 14.8501V10.5C21.5 4.7103 16.7897 0 11 0Z",
    fill: "#1E1531"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13092_122974"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.209dd6d7ffd591d20bc2662ba4d2285c.svg";
export { ForwardRef as ReactComponent };